var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('distributor-details')],1),_c('div',{staticClass:"col-12"},[_c('distributor-clients')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }